import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { t } from "i18next";
import confirmAccount from "@beeldit/user-and-access/auth/services/confirmAccount";

const AccountConfirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) {
      setError("invalid_token");
      setLoading(false);
      return;
    }

    confirmAccount(
      { token },
      (responseData: any) => {
        setLoading(false);
        if (responseData?.role === "producer") {
          navigate("/login?message=account_confirmed_can_login&messageType=success", { replace: true });
        } else {
          const publicHome = process.env.REACT_APP_PUBLIC_HOME_URL || "/";
          // Si es ruta relativa, usamos navigate; si es absoluta, cambiamos location (por si parte pública está fuera)
          if (/^https?:\/\//i.test(publicHome)) {
            window.location.replace(publicHome);
          } else {
            navigate(publicHome, { replace: true });
          }
        }
      },
      (e: any) => {
        setLoading(false);
        setError("invalid_token");
      }
    );
  }, [location.search, navigate]);

  if (loading) {
    return <div className="container py-5">{t("loading")}...</div>;
  }

  if (error) {
    return (
      <div className="container py-5 text-danger">
        {t(error) || t("invalid_token")}
      </div>
    );
  }

  return null;
};

export default AccountConfirmation;
